'use client';

import { Grid } from '@mantine/core';
import type { ReactNode } from 'react';

import { OutageCountSummary } from '../../../counts/summary/OutageCountSummary';
import { BriefModeDetails } from '../../../Mode/BriefModeDetails';

export function MenuSummary(): ReactNode {
	return (
		<section>
			<Grid gap={0}>
				<Grid.Col span={5}>
					<b>Mode</b>
				</Grid.Col>
				<Grid.Col span={7}>
					<BriefModeDetails />
				</Grid.Col>
			</Grid>
			<OutageCountSummary />
		</section>
	);
}
